import Divider from "../Divider";
import Icon from "../Icon";
import InlineLink from "../InlineLink";
import ProfileImage from "../ProfileImage";
import React from "react";
import ReactMarkdown from "react-markdown";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

export interface SpeakerInfoTabProps {
  firstname: string;
  lastname: string;
  title?: string;
  link: string;
  bio?: string;
  image?: string;
}

const SpeakerInfoTab = ({
  firstname,
  lastname,
  title,
  link,
  bio,
  image,
}: SpeakerInfoTabProps) => {
  return (
    <div className="relative w-full h-full">
      <div
        className="w-full h-full"
        style={{
          minHeight: "300px",
        }}
      >
        <div className="absolute top-0 left-0 w-full h-full overflow-y-scroll">
          <div className="space-y-8">
            <div className="flex justify-between">
              <div className="w-8/12 pr-4">
                <div className="space-y-2">
                  <div className="text-xl font-medium">
                    {title} {firstname} {lastname}
                  </div>
                  <div className="inline-block">
                    {link ? (
                      <InlineLink to={link}>
                        View Profile <Icon icon={faAngleRight} />
                      </InlineLink>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="w-4/12">
                <ProfileImage src={image} />
              </div>
            </div>
            <Divider />
            {bio ? (
              <div className="space-y-4 leading-relaxed text-gray-400">
                <ReactMarkdown source={bio.replace(/\\n/g, "\n")} />
              </div>
            ) : (
              <div className="w-full p-4 my-2 text-sm text-center text-gray-400 bg-gray-200 rounded">
                No speaker bio.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpeakerInfoTab;
